module.exports = __webpack_public_path__ + "static/img/example.25a81bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion/account/example.png
// module id = EtHs
// module chunks = 0